<template>
  <div id="nav-hamace">
    <div class="text-center">
      <h2 class="title line center">BTA Hammocks</h2>
      <div class="padding-onlytop-md">
        <p>
          Pentru că suntem perfecționiști, ne concentrăm producția pe un singur
          tip de hamac, disponibil în mai multe culori sau ediții speciale.
        </p>
        <p>
          În funcție de perioadă, sunt disponibile diverse culori. Dacă vrei să afli
          mai multe, ne poți contacta prin
          <a href="#nav-contact">formularul de contact</a>.
        </p>
      </div>
    </div>

    <div class="img-center">
      <b-row cols="1" cols-sm="1" cols-md="2" cols-lg="3">
        <b-col>
          <div class="single-person">
            <div class="content">
              <img src="/albastru.jpg" alt="" />
            </div>
          </div>
        </b-col>

        <b-col>
          <div class="single-person">
            <div class="content">
              <img src="/kaki.jpg" alt="" />
            </div>
          </div>
        </b-col>

        <b-col>
          <div class="single-person">
            <div class="content">
              <img src="/navy.jpg" alt="" />
            </div>
          </div>
        </b-col>

        <b-col>
          <div class="single-person">
            <div class="content">
              <img src="/rosu.jpg" alt="" />
            </div>
          </div>
        </b-col>

        <b-col>
          <div class="single-person">
            <div class="content">
              <img src="/verde-inchis.jpg" alt="" />
            </div>
          </div>
        </b-col>

        <b-col>
          <div class="single-person">
            <div class="content">
              <img src="/roz.jpg" alt="" />
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.text {
  padding: 50px 0;
  text-align: center;
}

.content {
  margin-bottom: 10px;
}

.img-center {
  text-align: center;
}

h2 {
  margin-top: 45px;
  color: #2f2911;
  text-transform: uppercase;
  position: relative;
  letter-spacing: 0;
  font-size: 26px;
  line-height: 40px;
  font-weight: 300;
}

.padding-onlytop-md {
  padding-top: 30px !important;
}

p {
  color: #6e6b66;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 16px;
  letter-spacing: 0.5px;
  font-weight: 300;
}

h2.title.line {
  margin-top: 45px;
}

h2.title.line:after {
  position: absolute;
  content: "";
  display: block;
  margin: 0 auto;
  left: 0;
  right: 0;
  z-index: -1;
  height: 40px;
  width: 2px;
  background-color: #0072bb;
  top: -50px;
}

.single-person img {
  width: 100%;
  height: auto;
  display: block;
}

.single-person .content {
  position: relative;
  border-radius: 2px;
  overflow: hidden;
  box-shadow: 0 0p 5px 0 rgba(0, 0, 0, 0.2);
}

#nav-hamace a {
  color: inherit;
}
</style>
